<template>
    
    <div class="main">
        <i>
            Atenção! Você lançará a situação acadêmica dos alunos para o ano letivo de 2023.<br>Importante: Os alunos que já tiveram a sua matrícula renovada 
            para o ano letivo de 2024, porém não foram aprovadas em 2023, você deverá realizar uma nova enturmação em 2024 por meio da coluna: <b>Nova Enturmação em 2024</b>
        </i>

        <c-panel>
            <situacao-academica></situacao-academica>
        </c-panel>
    </div>
    
</template>
<script>

import situacaoAcademica from "./situacao-academica"

export default {
    components:{ situacaoAcademica }
}
</script>
